import { useState } from 'react';

export const useMenuTriggerTooltip = (isMenuOpen: boolean) => {
  const [isRequested, setIsRequested] = useState(false);
  // MUI drops onClose while `open` is false, so a leave during the menu never clears the request.
  if (isMenuOpen && isRequested) {
    setIsRequested(false);
  }
  return {
    open: isRequested && !isMenuOpen,
    onOpen: () => {
      if (!isMenuOpen) {
        setIsRequested(true);
      }
    },
    onClose: () => setIsRequested(false)
  };
};
